import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-newsletter-send-list',
  templateUrl: './newsletter-send-list.component.html',
  styleUrls: ['./newsletter-send-list.component.scss']
})
export class NewsletterSendListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
